// extracted by mini-css-extract-plugin
export var address = "Footer-module--address--3t4dQ";
export var button = "Footer-module--button--MvcKZ";
export var ghostNav = "Footer-module--ghostNav--z3wvI";
export var info = "Footer-module--info--2FsRr";
export var socialLink = "Footer-module--socialLink--GKs4s";
export var symbol = "Footer-module--symbol--wuWqn";
export var wrapper = "Footer-module--wrapper--jJ9Zt";